OffersTimer = window.OffersTimer ?= {}
CountdownTimer = window.CountdownTimer ?= {}

CountdownTimer.Helpers = require '../../../groupon-deal-timer/common/helpers'

OffersTimer.Model = Backbone.Model.extend
  timeLeft: ->
    millisLeft = CountdownTimer.Helpers.millisRemaining @get('endAt')

    timeLeft: CountdownTimer.Helpers.timeRemaining millisLeft
    millisLeft: millisLeft

  buyUrlHash: ->
    urlHash = {}
    _.each @get('offerOptions'), (option) ->
      urlHash[option.buyUrl] = option.originalBuyUrl
    urlHash


module.exports = OffersTimer.Model
